import * as CONST from '../utils/constants';
import Util from '../utils/ui';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

class Search {
	constructor() {
		// header
		this.headerSearchWrap = $('.js-search');
		this.headerOffset = document.getElementById("header").offsetTop;

		// search
		this.searchToggle = $('.js-search-toggle');
		this.searchWrap = $('.js-search');
		this.closeSearchToggle = $('.js-close-search');

		this.searchForm = $('.js-search-form');
	}

	init() {
		this.bindEvents();
	}

	bindEvents() {
		// search toggle
		this.searchToggle.on('click', e => { e.stopPropagation(); this.expandSearch(); });
		this.closeSearchToggle.on('click', e => { e.stopPropagation(); this.closeSearch(); });

		// search form on enter input or button
		this.searchForm.find('.form-control').on('keydown', e => { if (e.keyCode === 13) { this.searchTerm(e); } });
		this.searchForm.find('.btn').on('click', e => { this.searchTerm(e); });

		$(window).on('resize', e => this.onResize(e));
	}

	onResize(e) {
		if (Util.getViewPort() === CONST.ViewPort.Desktop) {
			this.searchWrap.removeClass('open');
		}
	}

	closeSearch() {
		this.searchWrap.removeClass('open');
	}

	// expanding search in header
	expandSearch() {
		let input = this.headerSearchWrap.find('input[type="search"]');

		if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
			// open menu and focus on search
			this.searchWrap.addClass('open');
			input.focus();
		}
	}

	searchTerm(e) {
		e.preventDefault();

		let target = $(e.currentTarget).closest('div');
		let input = $(target).find('.form-control');

		let value = $(input).val();
		let name = $(input).attr('name');
		let action = $(target).closest('.js-search-form').data('action');

		if ($('body').hasClass('magazine-layout')) {
			window.location = `/magazine/${action}#/?${name}=${encodeURIComponent(value)}`;
		}
		else {
			window.location = `/${action}?${name}=${encodeURIComponent(value)}`;
		}		
	}
}

export default Search;